import { SxProps } from '@mui/material';
import React, { Fragment, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog, QrCode, QrCodeIcon } from 'components';

type Props = {
  data: string;
  title?: string;
  sx?: SxProps;
};

export const QrCodeWithDialog: React.FC<Props> = ({ data, title, sx }) => {
  const { t } = useTranslation();
  const displayTitle = title || t('components.qr_code.title');
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setDialogOpen(false);
  }, []);

  return (
    <Fragment>
      <QrCodeIcon onClick={handleClick} sx={sx} title={displayTitle} />
      <Dialog open={dialogOpen} onClose={handleCloseDialog} hideCancel hideOk>
        <QrCode data={data} />
      </Dialog>
    </Fragment>
  );
};
